import { timestampDate } from '@bufbuild/protobuf/wkt';
import {
  Event,
  EventType,
} from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/event_pb';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';

export class SystemEventModel {
  key: number;

  type: EventType;

  time?: string;

  payload: { key: string; value: string }[];

  user: string;

  productionStateChange?: string;

  constructor(event: Event, uniqueKey: number) {
    this.key = uniqueKey;
    this.type = event.type;

    this.time = dayjs(
      event.lastOccuranceTime && timestampDate(event.lastOccuranceTime),
    ).format('YYYY-MM-DD HH:mm:ss');
    this.payload = event.payloadInfo.map(({ key, value }) => ({
      key,
      value,
    }));

    this.user =
      this.payload.find((p) => p.key === 'User Email')?.value || '---';

    this.productionStateChange = this.payload.find(
      (p) => p.key === 'Data',
    )?.value;
  }

  getDescription(t: TFunction): string {
    switch (this.type) {
      case EventType.SYSTEM_PRODUCTION_STATE_UPDATED:
        return t('systemAdmin.events.productionStateUpdate', {
          change: this.productionStateChange || 'N/A',
        });
      case EventType.ENABLE_AUTO_MODE_COMMAND_FINISHED:
        return t('systemAdmin.events.autoModeEnabled');
      case EventType.DISABLE_AUTO_MODE_COMMAND_FINISHED:
        return t('systemAdmin.events.autoModeDisabled');
      default:
        return EventType[this.type];
    }
  }
}
